/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Actions_Aria_LabelInputs */

const en_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Actions`)
};

const fr_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions de preset`)
};

const de_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreingestellte Aktionen`)
};

const it_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni preimpostate`)
};

const ru_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные действия`)
};

const es_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones preestablecidas`)
};

const zh_cn2_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设操作`)
};

const ja_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットアクション`)
};

const hi_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्व निर्धारित क्रियाएँ`)
};

const pt_pt2_styles_preset_actions_aria_label = /** @type {(inputs: Styles_Preset_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações predefinidas`)
};

/**
* | output |
* | --- |
* | "Preset Actions" |
*
* @param {Styles_Preset_Actions_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_actions_aria_label = /** @type {((inputs?: Styles_Preset_Actions_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Actions_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_preset_actions_aria_label(inputs)
	if (locale === "de") return de_styles_preset_actions_aria_label(inputs)
	if (locale === "it") return it_styles_preset_actions_aria_label(inputs)
	if (locale === "ru") return ru_styles_preset_actions_aria_label(inputs)
	if (locale === "es") return es_styles_preset_actions_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_preset_actions_aria_label(inputs)
	if (locale === "ja") return ja_styles_preset_actions_aria_label(inputs)
	if (locale === "hi") return hi_styles_preset_actions_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_preset_actions_aria_label(inputs)
	return en_styles_preset_actions_aria_label(inputs)
});